<template>
    <div class="d-flex align-items-center">
        <font-awesome-icon icon="fa-solid fa-pen-to-square" class="text-primary" />
        <b-dropdown :text="$gettext('Change')" variant="bg-transparent text-primary" class="ui-dashboard-menu-dropdown">
            <b-dropdown-item @click="changeBillingUrl" variant="info">
                <font-awesome-icon icon="fa-solid fa-pen-to-square" class="text-info" /><translate>Change billing cycle</translate>
            </b-dropdown-item>
            <b-dropdown-item @click="paymentDetailsUrl" variant="info">
                <font-awesome-icon icon="fa-solid fa-pen-to-square" class="text-info" /><translate>Change payment details</translate>
            </b-dropdown-item>
            <b-dropdown-item @click="cancelSubscriptionUrl" variant="danger">
                <font-awesome-icon icon="fa-solid fa-xmark" class="text-danger" /><translate>Cancel subscription</translate>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
export default {
    name: "ActionButtonChange",
    methods: {
        changeBillingUrl() {
            this.$router.push({name: "UpgradeSubscription"});
        },
        paymentDetailsUrl() {
            this.$router.push({name: "PaymentDetails"});
        },
        cancelSubscriptionUrl() {
            this.$router.push({name: "DowngradeSubscription", params: {subscriptionId: this.$store.getters['subscriptionStore/getSubscription'].id}});
        }
    },
}
</script>

<style scoped>

</style>